module.exports = __webpack_public_path__ + "static/media/sliderbg.f4f0293f.webp";